module.exports = __webpack_public_path__ + "static/media/_dash.07d7c200.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/alphabet/_dash.jpg
// module id = 63
// module chunks = 0